<template>
  <div>
    <Loader
      v-show="loading"
      :loading="loading"
    />
    <v-card>
      <v-card-title>
        <v-row no-gutters>
          <span class="headline font-weight-medium">{{ header }}</span>
          <v-spacer />
          <IconBtn
            icons="close"
            :large="true"
            color="grey darken-4"
            @click="close"
          />
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <CustomTextField
              v-model="name"
              label="Назва"
              :hide-details="true"
              :required="true"
              :error-messages="$v.name.$invalid ? errors.TITLE : []"
              @input="isChanged = true"
            />
          </v-col>
          <v-col>
            <CustomTextField
              v-model="legalName"
              label="Юридична назва"
              :hide-details="true"
              @input="isChanged = true"
            />
          </v-col>
          <v-col>
            <CustomTextField
              v-model="edrpou"
              label="Код ЄДРПОУ"
              :hide-details="true"
              @input="isChanged = true"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <PrimaryBtn
          :loading="loading"
          :disabled="!isChanged || isFormInvalid"
          @click="save"
        />
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import * as clientsApi from "../../backend/clientsApi.js";
import Loader from "../../../components/Loader.vue";
import IconBtn from "../../../components/IconBtn.vue";
import PrimaryBtn from "../../../components/PrimaryBtn.vue";
import CustomTextField from "../../../components/CustomTextField.vue";
import { ERRORS } from "@/helpers";
import { required } from "vuelidate/lib/validators";

export default {
  components: {
    Loader,
    IconBtn,
    PrimaryBtn,
    CustomTextField,
  },
  props: ["id"],
  data: () => ({
    loading: false,
    isChanged: false,
    name: "",
    legalName: "",
    edrpou: "",
  }),
  validations: {
    name: {
      required,
    },
  },
  computed: {
    isFormInvalid(){
      return this.$v.name.$invalid;
    },

    isNew() {
      return this.id != 0 ? false : true;
    },
    header() {
      return this.isNew ? "Створення контрагента" : "Редагування контрагента";
    },
    errors() {
      return {
        TITLE: [ERRORS.REQUIRED],
      };
    },
  },
  created() {
    if (this.id != 0) {
      clientsApi.getClient(this.id).then((entity) => {
        this.name = entity.name;
        this.legalName = entity.legalName;
        this.edrpou = entity.edrpou;
      });
    }
  },
  methods: {
    async save() {
      this.loading = true;

      const newEntity = {
        name: this.name,
        legalName: this.legalName,
        edrpou: this.edrpou,
      };

      if (this.id == 0) {
        await clientsApi
          .createClient(newEntity)
          .then(() => {
            this.$router.push({ path: "/sales-clients" });
          });
      } else {
        await clientsApi.updateClient(this.id, newEntity);
        this.$notifySuccess();
      }
      this.loading = false;
    },
    close() {
      if (this.modal) {
        this.$emit("close");
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>